import React, { useState, useEffect, useContext } from 'react';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

import * as utils from "../../../assets/utils";

import * as net from "../../../lib/net";
import Fr_Input from "../../../lib/ui/fr_input";
import Fr_Select from "../../../lib/ui/fr_select";

class Pres_Trs_Edit extends React.Component {
  constructor(props, context) {
    super(props);

    this.pos = props.store.pos;
    this.state = {};
    this.state.mka = [];
    this.state.sval = [];
    this.state.tval = [];
    this.state.paa = [];
    this.state.uaa = [];
    this.state.laa = [];

    this.state.sz_val = "";
    this.state.gnr = "001";
    this.state.ynq = [
                {id: '0', text: 'NEJ'},
                {id: '1', text: 'JA'}
            ];

            this.state.wnds = {};
    this.state.cols = {};
    this.state.tro = {};

    if(props.wnds.tro) {
        this.state.tro = props.wnds.tro;
    }
  }
  componentDidUpdate() {
  }
  componentWillUnmount() {
  }
  componentDidMount() {
      //if(!this.props.wnds.pro) this.preg_init();
  }

    preg_init() {
        var udo = {};
        udo.e1bastyp = "";
        udo.e1typ = "";
        udo.e1blank = "";
        udo.e1kontonr = "";
        udo.e1text = "";
        udo.e1debcre = "";
        udo.e1moms = "";
        udo.e1pris = "";
        udo.e1mattyp = "";
        udo.e1kassabal = "";
        udo.e1cancelled = "";
        udo.e1paytrans = "";
        udo.e1man_rep = "";
        udo.e1no_avail = "";
        //alert(JSON.stringify(rso));
        this.setState({ udo: udo });
        return;
    }

    dlg_style() {
      var css = {};
      //css.width = window.innerWidth * 0.8;
      //css.height = window.innerHeight * 0.8;
      return css;
    }

    formchange (e) {
      const name = e.target.name;
      const value = e.target.value;
      var pbo = this.state.pbo;
      var na = name.split(".");
      pbo[na[0]][na[1]] = value;
      this.setState({pbo: pbo});
      //setState({[name]: value});
    }

    handleUserInput (e) {
      const name = e.target.name;
      const value = e.target.value;
      var user = this.state.user;
      user[name] = value;
      this.setState({user: user});
      //setState({[name]: value});
    }
    wnd_close = () => {
      if(this.props.close) {
          this.props.close(this.props.ctx);
      }
      else this.props.ctx.setState({ wnds: {} });
	};
    handleChange = (event, newValue) => {
        //alert(newValue);
        this.setState({ix: newValue});
      };
    toggle() {
      this.setState({modal: false});
	};

  submitHandler = event => {
    event.preventDefault();
    event.target.className += " was-validated";
  };

  changeHandler = event => {
    this.setState({ [event.target.name]: event.target.value });
  };

  val_save(id, val) {
    var tro = this.state.tro;
    //var f0 = id.split(".")[0];
    //var f1 = id.split(".")[1];
    
    //tro[f0][f1] = val;
    tro[id] = val;

    this.setState({ tro: tro });
    return;
}

tb_style() {
      var css = {};
      css.height = window.innerHeight - 275;
      return css;
  }
  cssCols (cid) {
      var css = {};
      if(this.state.cols[cid]) css.width = this.state.cols[cid].toString() + "px";
      //if(cid == "c01") alert(JSON.stringify(this.state.cols[cid]));
      return css;
  }
  trs_save() {
    var self = this;
    var prm = {};
    prm.req = "crs.crs_trs.trs_upd";
    prm.tro = this.state.tro;
    //prm.sid = "S0001611";

    //net.sid_req(prm)
    net.sio_req(prm)
    .then(function(ret){
        //alert(JSON.stringify(ret));
        if(ret.ok == "000") {

            self.setState({wnd_ok: true });
            setTimeout(function(){
                self.setState({wnd_ok: false });
                  if(self.props.wnds.cb) {
                      self.props.wnds.cb(self.props.ctx);
                  }
                  else self.props.ctx.setState({ wnds: {} });
                return;
            }, 1000);
        
        }
    })
    .catch(function(e){
        var txt = JSON.stringify(e);
    });
  }


  sz_keydown (e) {
        //e.preventDefault();
        const key = e.key;
        const keyCode = e.keyCode;

        if(keyCode == 13) {
            this.plu_sz();
        };
        if(keyCode == 27) {
            this.setState({sz_val: ""});
        };
    }
    sz_change (e) {
        const name = e.target.name;
        const value = e.target.value;
        this.setState({sz_val: value});
        //setState({[name]: value});
    }

  render() {
    //if(!this.props.show) return "";
    var title = this.props.title;
    if(!title) title = "UDID";
    //if(props.kro) alert(props.kro.krr00.kid);

	var html =
        <div className="mx_base">
        <div className="m2_backdrop" />
        <div className="m2_dlg mx_50 flex-col" style={ this.dlg_style() } >
        <div className="mx_top flex-row">

            <div className="txt-22">
                <div>TRANSAKTION</div>
            </div>
            <div className="flex"></div>
            <div>UPPDATERA</div>
        </div>
            <div className="divider_orange"></div>

            <form className="cdi_f03">
                <div className="flex-row">
                        <Fr_Input label="Nyckel" className="text-left w350" text={ this.state.tro.p0key } getValue={(e)=> this.val_save("p0key", e) } />
                </div>
                <div className="flex-row">
                    <Fr_Input label="Datum" className="text-left w150" text={ this.state.tro.p0datum } getValue={(e)=> this.val_save("p0datum", e) } />
                    <Fr_Input label="Tid" className="text-left w150" text={ this.state.tro.p0tid } getValue={(e)=> this.val_save("p0tid", e) } />
                </div>

                <div className="divider_green"></div>

                <div className="flex-row">
                    <Fr_Input label="Belopp" className="text-right w250" text={utils.toPris( this.state.tro.p0belopp )} getValue={(e)=> this.val_save("p0belopp", e) } />
                </div>
                <div className="flex-row">
                    <Fr_Input label="Tecken" className="text-right w250" text={this.state.tro.p0tkn} getValue={(e)=> this.val_save("p0tkn", e) } />
                </div>
                <div className="flex-row">
                    <Fr_Input label="Saldo" className="text-right w250" text={utils.toPris( this.state.tro.p0saldo )} getValue={(e)=> this.val_save("p0saldo", e) } />
                </div>
            </form>

            <div className="flex"></div>

        <div className="mx_foot flex-row flex-space-between">
            <button className="btn btn-hw-red w250" onClick={() => this.wnd_close() } >
                STÄNG
            </button>
            

            <div className="flex-row">
            <button className="btn btn-hw-green w250" onClick={() => this.trs_save() } >
                SPARA
            </button>
            </div>
        </div>
      </div>

      </div>
	;
	return html;
  };
}

export default Pres_Trs_Edit;